import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  statusCode?: number;
  title?: string;
  message?: string;
  showButton?: boolean;
}

const Error: React.FC<Props> = props => {
  const {
    statusCode = 403,
    title = 'Access Denied',
    message = 'You don’t have permission to view this page.',
    showButton = true,
  } = props;
  const navigate = useNavigate();

  return (
    <div className="login-page">
      <div className="container-xxl h-100 my-auto">
        <div className="error-page">
          <h1 className="text-primary">{statusCode}</h1>
          <h2 className="fw-semibold">{title}</h2>
          <h5 className="text-gray-700 fw-normal">{message}</h5>

          {showButton && (
            <button className="btn btn-primary btn-lg mt-4" onClick={() => navigate(-1)}>
              <i className="ia-arrow-left me-2"></i>
              Go back
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Error;
